import { SET_POOLS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_POOLS:
      return action.payload;
    default:
      return state;
  }
};
